import { CATALOG_SUMMAY_REQUEST } from './action-types';
import {CATATLOG_COUNT, IS_LOADING} from "./mutation-types"
import api from "@/api/api"

export default {

    [CATALOG_SUMMAY_REQUEST]: async ({ commit })=>{
        let response = {}
        try {
            response =   await api.get("/catalogs/summary")
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                 commit(CATATLOG_COUNT, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false)
        }
        return response
    },
}
